<p-fileUpload name="myfile[]" accept="image/*" [maxFileSize]="maxFileSize" showUploadButton="false" showCancelButton="false" multiple="multiple"
  auto="true" customUpload="true" (uploadHandler)="fileUploadEvent($event)" (onSelect)="onSelectEvent($event)">
  <ng-template pTemplate="content">
    <div class="custom-file-upload-content">
      <i class="fa fa-cloud-upload fa-4x"></i>
      <div class="custom-file-upload-header">
        <label>Drag & Drop</label>
      </div>
      <div class="custom-file-upload-sub-header">
        <label>your image here...</label>
      </div>
    </div>
  </ng-template>
</p-fileUpload>
